import {
    Modal,
    ModalContent,
    ModalBody,
    ModalFooter,
    useDisclosure,
    Button,
    ModalHeader,
} from "@nextui-org/react";

import { getFrames } from "../../api-route/frame";
import { mergeImage } from "../../api-route/mergeImage";
import { Pagination } from "@nextui-org/react";
import { BaseURL } from "../../config/axios";
import { useEffect, useRef, useState } from "react";
import FrameDetail from "./FrameDetail";

export default function SelectFrame({ setFrame, setMainImage, id, width }) {
    const [currentpage, setCurrentpage] = useState(1)
    const pagination = useRef()
    const { isOpen, onOpen, onOpenChange } = useDisclosure()
    const [frames, setFrames] = useState([])
    const [image, setImage] = useState("/images/none.png")

    useEffect(() => {
        const get = async () => {
            const Frames = await getFrames({ page: currentpage });
            setFrames(Frames ? Frames.data : [])
            pagination.current = Frames ? Math.ceil(Frames.total / Frames.per_page) : 1
        }
        get()
    }, [currentpage])

    useEffect(() => {
        setFrame({ id: null })
        setImage("/images/none.png")
    }, [id])

    const handleClick = async (frame) => {
        const img = frame.part_frame_image
        setImage(img ? BaseURL + img.path : "/images/none.png")
        setFrame(img ? frame : { id: null })
        const image_with_frame = await mergeImage(id, frame.id, width)
        setMainImage(BaseURL + image_with_frame.merged_path)
        onOpenChange(false)
    }

    return (
        <div className="w-full h-[194px] border-1 border-gray-600 rounded-lg mt-3 mb-5 overflow-hidden">
            <button onClick={onOpen} className="w-full h-full">
                <img width={100} height={100} src={image} className="w-full h-full object-contain" />
            </button>

            {!!frames.length &&
                <Modal isOpen={isOpen} hideCloseButton={true} scrollBehavior={'inside'} onOpenChange={onOpenChange}
                    size="5xl">
                    <ModalContent>
                        {(onClose) => (
                            <>
                                <ModalHeader dir="rtl" />
                                <ModalBody>
                                    <div>
                                        <div className="grid lg:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-2">
                                            <div className="col-span-1 max-w-[400px] h-[300px] overflow-hidden">
                                                <div
                                                    className="h-full w-full flex flex-col rounded-lg bg-gray-50 border border-gray-200 text-center">
                                                    <div className="centerOfParent p-2 h-[170px] overflow-hidden">
                                                        <img width={100} height={100}
                                                            className="w-full h-full"
                                                            src="/images/none.png"
                                                            alt='none'
                                                            layout="responsive"
                                                        />
                                                    </div>
                                                    <div className="px-1 py-2 grow flex flex-col gap-2">
                                                        <div className="text-primary text-sm font-medium line-clamp-1">
                                                            بدون قاب
                                                        </div>
                                                        <hr />
                                                        <div className="text-xs">
                                                        </div>
                                                        <hr />
                                                        <div className="centerOfParent gap-2 grow">
                                                            <Button size="sm" className="bg-primary text-white"
                                                                onClick={() => handleClick({ images: [] })}>انتخاب</Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {frames.map(f => {
                                                return (
                                                    <div className="col-span-1 max-w-[400px] h-[300px] overflow-hidden"
                                                        key={f.id}>
                                                        <div
                                                            className="h-full w-full flex flex-col rounded-lg bg-gray-50 border border-gray-200 text-center">
                                                            <div onClick={() => handleClick(f)}
                                                                className="centerOfParent p-2 overflow-hidden cursor-pointer">
                                                                <img
                                                                    className="w-full h-[170px] mx-auto shadow-lg object-contain"
                                                                    src={BaseURL + f.part_frame_image?.path}
                                                                    alt={f.title}
                                                                    title={f.id}
                                                                    width={100} height={100}
                                                                />
                                                            </div>
                                                            <div className="px-1 py-2 grow flex flex-col gap-2">
                                                                <div className="flex flex-col gap-2">
                                                                    <div onClick={() => handleClick(f)}
                                                                        className="text-primary text-sm font-medium line-clamp-1 cursor-pointer">
                                                                        {f.title}
                                                                    </div>
                                                                    <hr />
                                                                    <div className="text-xs">
                                                                        عرض: {f.width}
                                                                    </div>
                                                                    <hr />
                                                                </div>
                                                                <div className="centerOfParent gap-2 grow">
                                                                    <FrameDetail id={f.id} />
                                                                    <Button size="sm" className="bg-primary text-white"
                                                                        onClick={() => handleClick(f)}>انتخاب</Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <div dir="auto" className="centerOfParent mt-4">
                                            {!!frames.length && pagination.current > 1 &&
                                                <Pagination size='sm'
                                                    total={Math.ceil(pagination.current)}
                                                    color="primary"
                                                    page={currentpage}
                                                    onChange={setCurrentpage}
                                                    showControls
                                                />}
                                        </div>
                                    </div>
                                </ModalBody>
                                <ModalFooter dir="rtl">
                                    <Button variant="flat" onClick={onClose} color="danger">
                                        بستن
                                    </Button>
                                </ModalFooter>
                            </>
                        )}
                    </ModalContent>
                </Modal>}
        </div>
    );
}
